import React from 'react';

import { colors } from 'styles/provider';

const dividerStyle = {
  borderTop: `1px solid ${colors.clrGray}`,
  margin: '2rem 0',
  width: '100%',
  height: '1px',
};

const Divider = () => <div style={dividerStyle} />;

export default Divider;
